import http from 'helpers/http';
import { getDeviceId, getRefNo } from 'helpers/helpers';
import { PRIZE_TYPE } from 'helpers/constants';

export const getHome = () => http.get(`/screen/home`);
const deviceIdCommon = getDeviceId();
// Ong
export const getGameCodeList = (params) => async (dispatch, getState) => {
  try {
    const result = await http.post(``, {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/getGameCodeList",
      requestBody: {
        refNo: getRefNo(deviceIdCommon),
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST",

    });
    return result;
  } catch (error) {
    throw error;
  }
}

export const dial = (params) => async (dispatch, getState) => {
  try {
    const result = await http.post(``, {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/embeeReward/dial",
      requestBody: {
        gameCode: params.gameCode
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST"
    });
    return result;
  } catch (error) {
    throw error;
  }
}

export const getInfo = (params) => async (dispatch, getState) => {
  try {
    const result = await http.post(``, {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/embeeReward/getInfo",
      requestBody: {
        refNo: getRefNo(deviceIdCommon),
        gameCode: params.gameCode
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST",
    });
    return result;
  } catch (error) {
    throw error;
  }
}

export const getHistoryFilter = (params) => async (dispatch, getState) => {

  try {
    const result = await http.post(``, {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/embeeReward/getHistoryFilter",
      requestBody: {
        type: params.gameCode,
        prizeType: params.prizeType === PRIZE_TYPE.COIN ? "COIN" : params.prizeType
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST",
    });
    console.log("Getting history.....")
    return result;
  } catch (error) {
    throw error;
  }
}


export const gameRanking = params => async (dispatch, getState) => {
  try {
    const result = await http.post('', {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/embeeReward/gameRanking",
      requestBody: {
        gameCode: params.gameCode,
        quantity: params.quantity
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST",
    })
    return result;
  } catch (error) {
    throw error;
  }

}

export const magicRewardReception = params => async (dispatch, getState) => {
  try {
    const result = await http.post('', {
      refNo: getRefNo(deviceIdCommon),
      url: "/retail-go-gamems/embeeReward/magicRewardReception",
      requestBody: {
        gameCode: params.gameCode,
        magicMonth: params.magicMonth
      },
      deviceIdCommon: deviceIdCommon,
      method: "POST",
    })
    return result;
  } catch (error) {
    throw error;
  }

}